import '@/styles/components/ui/LoadingOverlay.scss';

// Functions to show and hide the overlay
export function showLoading() {
    const overlay = document.getElementById('loading-overlay');
    if (overlay) overlay.style.display = 'flex';
}

export function hideLoading() {
    const overlay = document.getElementById('loading-overlay');
    if (overlay) overlay.style.display = 'none';
}

const LoadingOverlay = () => (
    <div id="loading-overlay" className="loading-overlay">
        <div className="spinner"></div>
    </div>
);

export default LoadingOverlay;
